import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function ChargeMenu(_ref) {
  let params = _ref.params,
    setActiveTransaction = _ref.setActiveTransaction,
    invokeEditModal = _ref.invokeEditModal,
    invokeCancelModal = _ref.invokeCancelModal;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEditClick = () => {
    setActiveTransaction(params);
    handleClose();
    invokeEditModal();
  };
  const handleDeleteClick = () => {
    setActiveTransaction(params);
    handleClose();
    invokeCancelModal();
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "charge menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '47-charge-menu'
  }, /*#__PURE__*/React.createElement("span", null, t('general.edit')), /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: handleEditClick,
    'custom-attribute': '45-charge-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: handleDeleteClick,
    'custom-attribute': '46-charge-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), t('buttons.cancel'))));
}